(() => {
  if (!customElements.get('mp-product-guide')) customElements.define('mp-product-guide', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.addEventListener('click', e => {
        const button = e.target.closest('button');
        if (!button || !this.contains(button)) return;
        let step;
        if (button.dataset.audience) { this.dataset.audience = button.dataset.audience; step = '2'; }
        if (button.dataset.choice) {
          this.querySelectorAll('[data-choice-result]').forEach(card => { card.hidden = card.dataset.choiceResult !== button.dataset.choice; });
          step = '3';
        }
        if (button.dataset.back) step = button.dataset.back;
        if (!step) return;
        this.querySelectorAll('[data-choice-step]').forEach(panel => { panel.hidden = panel.dataset.choiceStep !== step; });
        this.querySelector(`[data-choice-step="${step}"] h3`).focus({preventScroll:true});
      });
    }
  });
})();
